import { BaseModel, attr, belongsTo } from "../../lib/itn-ui-kit/data";

export default class CaseModel extends BaseModel {
  static urlPath = "case";

  @attr("number") pk;
  @attr("boolean") accidentPicturesReceived;
  @attr("number") actualTotalSettlementNumber;
  @attr("boolean") allMedicalDocsReceived;
  @attr("boolean") allTreatmentsComplete;
  @attr("number") appointmentsCt;
  @attr("boolean") archived;
  @attr("json") assigned;
  @attr("string") callbackReason;
  @attr("string") callbackTime;
  @attr("number") campaign;
  @belongsTo("client") client;
  @attr("number") clientSettlementAmount;
  @attr("boolean") crashReportReceived;
  @attr("datetime") createdAt;
  @attr("date") dateOfAccident;
  @attr("json") entity;
  @attr("boolean") hasCheck;
  @attr("string") incidentCity;
  @attr("number") incidentLocation;
  @attr("number") incidentRole;
  @attr("number") incidentType;
  @attr("string") incidentDescription;
  @attr("date") statuteOfLimitations;
  @attr("datetime") incidentSettlementDate;
  @attr("boolean") introducedToNp;
  @attr("datetime") lastContacted;
  @attr("number") lawFirm;
  @attr("string") lawFirmName;
  @attr("string") legalStatus;
  @attr("string") actualTotalSettlementAmount;
  @attr("string") medPayAmount;
  @attr("number") medicalLimits;
  @attr("string") overallStatus;
  @attr("string") status;
  @attr("boolean") medicalStatusLocked;
  @attr("string") currentBalanceTotal;
  @attr("string") runningTotal;
  @attr("array") relatedCases;
  @attr("string") movingViolation;
  @attr("string") providerMax;
  @attr("number") propertyDamageSeverity;
  @attr("string") propertyDamageAmount;
  @attr("string") policeReportNumber;
  @attr("array") medicalStatusCounts;
  @attr("string") name;
  @attr("string") comboName;
  @attr("datetime") updatedAt;
  @attr("string") supervisorNeededReason;
  @attr("datetime") supervisorNeededReasonUpdatedAt;
  @attr("string") relativeUpdatedAt;
  @attr("string") reductionReceivedFrom;
  @attr("string") reductionReceivedDate;
  @attr("string") reductionApprovedDate;
  @attr("string") reductionCompletedDate;
  @attr("string") settlementFinalizedOn;
  @attr("string") insuranceSettlementDate;
  @attr("string") lawyerSettlementAmount;
  @attr("string") lawyerSettlementCosts;
  @attr("string") lawyerTotalCosts;
  @attr("json") updatedBy;
  @attr("json") createdBy;
  @attr("json") lost;
  @attr("boolean") policeReportReceived;
  @attr("string") label;
  @attr("string") address;
  @attr("string") latitude;
  @attr("string") longitude;
  @attr("boolean") showSearch;
  @attr("datetime") reductionApprovedAt;
  @attr("string") reductionApprovedBy;
}
